import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { tArray } from 'cityads-v3/i18n/utils';

import Article, { ArticleImage } from 'cityads-v3/components/Article';

type APIProps = {
  inPopup?: boolean
}

export default function API(props: APIProps): JSX.Element {
  const { t } = useTranslation(['API']);

  return (
    <Article
      title={t('title')}
      pageTitle={t('pageTitle')}
      pageDescription={t('pageDescription')}
      pageKeywords={t('pageKeywords')}
      {...props}
    >
      {tArray(t, 'p1', 'p')}

      <ArticleImage
        src={require('./img1.png')}
        caption={t('imageCaption')}
      />

      {tArray(t, 'p2', 'p')}

      <ul>
        {tArray(t, 'list1', 'li')}
      </ul>
      <p>
        {t('p3')}
      </p>
      <p>
        <Link to="/publisher/api/description">{t('link')}</Link>
      </p>
    </Article>
  );
}
